import { useState, useEffect, useCallback } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { OtpServices } from "../services/OtpServices";
import { HospitalServices } from "../services/HospitalServices";
import { CircularProgress, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Select from "react-select";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./TmsOtpLogsList.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import TmsOtpLogsModal from "./TmsOtpLogsModal";
import CustomPagination from "../utils/paginationUtils";
const TmsOtpLogsList = () => {
  const [summaryData, setSummaryData] = useState([]);
  const [hospitalList, setHospitalList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isHospitalLoading, setHospitalLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [hospitalId, setHospitalId] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [limit, setLimit] = useState(10);
  const [error, setError] = useState(null);
  const getDate = (dateString) => {
    if (!dateString) return "--";
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (e) {
      return "--";
    }
  };
  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [hospitalLogs, setHospitalLogs] = useState([]);
  const { newOtpMessage } = useSelector((store) => store.notificationReducer);

  // Debounced search
  const handleSearch = useCallback((e) => {
    const value = e.target.value;
    setSearchKey(value);
    setPage(1); // Reset to first page on new search
  }, []);

  const getSummaryData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await OtpServices.getDmOtpLogsSummary(
        page,
        limit,
        searchKey,
        hospitalId,
        fromDate,
        toDate
      );

      if (!res.data || !res.data.dmUserLog) {
        throw new Error("Invalid data format from server");
      }

      setSummaryData(res.data.dmUserLog);
      setTotalPages(res.data.totalPages || 1);
    } catch (error) {
      console.error("Failed to fetch OTP logs summary:", error);
      setError("Failed to load OTP logs. Please try again.");
      handleApiErrorResponses(error);
      setSummaryData([]);
    } finally {
      setLoading(false);
    }
  }, [page, limit, searchKey, hospitalId, fromDate, toDate]);

  const getHospitalList = useCallback(async () => {
    try {
      setHospitalLoading(true);
      const response = await HospitalServices.gethospitals("", 1, 1500);

      if (!response.data || !Array.isArray(response.data.list)) {
        throw new Error("Invalid hospital data format");
      }

      setHospitalList(response.data.list);
    } catch (error) {
      console.error("Failed to fetch hospitals:", error);
      toast.error("Failed to load hospital list");
      setHospitalList([]);
    } finally {
      setHospitalLoading(false);
    }
  }, []);

  const openModal = useCallback((logs) => {
    if (!logs || !Array.isArray(logs)) {
      toast.warning("No logs available to display");
      return;
    }
    setHospitalLogs(logs);
    setModalOpen(true);
  }, []);

  // Handle hospital filter change
  const handleHospitalChange = useCallback((item) => {
    setPage(1); // Reset to first page when filter changes
    setHospitalId(item ? item.id : "");
  }, []);

  useEffect(() => {
    getSummaryData();
  }, [getSummaryData]);

  useEffect(() => {
    getHospitalList();
    window.scrollTo(0, 0);
  }, [getHospitalList]);

  // Reset error when component unmounts
  useEffect(() => {
    return () => {
      setError(null);
    };
  }, []);

  return (
    <div className="tms-otp-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Digital Medco OTP Logs
      </span>

      <div className="heading">
        Digital Medco OTP Logs
        <div className="text-[16px] flex items-center gap-4">
          <Select
            name="hospitalId"
            isClearable
            isLoading={isHospitalLoading}
            isDisabled={isHospitalLoading}
            options={hospitalList}
            getOptionLabel={(options) => options["name"] || "Unknown"}
            getOptionValue={(options) => options["id"]}
            onChange={handleHospitalChange}
            value={hospitalList.filter((item) => item.id === hospitalId)}
            placeholder="FILTER HOSPITAL WISE"
            noOptionsMessage={() => "No hospitals found"}
            loadingMessage={() => "Loading hospitals..."}
          />
          <div className="flex gap-2 items-center py-2 px-4 bg-white rounded-[8px]">
            <SearchIcon className="text-xl" />
            <input
              type="text"
              className="outline-none border-none"
              placeholder="Search Mobile Number"
              onChange={handleSearch}
              value={searchKey}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center gap-4 mb-4">
        <div>
          <label htmlFor="start-date">From Date:</label>
          <input
            type="date"
            id="from-date"
            // value={formatDate(startDate)}
            onChange={(e) => setFromDate(new Date(e.target.value))}
            // max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>

        <div>
          <label htmlFor="end-date">To Date:</label>
          <input
            type="date"
            id="to-date"
            // value={formatDate(endDate)}
            onChange={(e) => setToDate(new Date(e.target.value))}
            // max={formatDate(new Date())}
            style={{ border: "1px solid #E5E5E5" }}
            className="text-[#191919] appearance-none p-2 rounded-[8px] "
          />
        </div>
      </div>
      <div style={{ border: "1px solid #E7E7E7", marginBottom: "20px" }} />

      {error ? (
        <div className="flex justify-center items-center h-64">
          <Typography color="error">{error}</Typography>
        </div>
      ) : isLoading ? (
        <div className="flex justify-center items-center h-64">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <div className={`grid grid-cols-4 text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Hospital Name
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                TMS Mobile
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Total Logs
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Last Log Time
              </div>
            </div>
          </div>

          {summaryData && summaryData.length > 0 ? (
            summaryData.map((item, idx) => (
              <div
                key={`${item.hospitalId}-${item.mobileNo}-${idx}`}
                className={`py-6 px-8 rounded-[16px] ${
                  idx % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"
                }`}
              >
                <div className={`grid grid-cols-4 text-[#797979] text-[18px]`}>
                  <div>
                    <div>{item?.hospital?.name || "--"}</div>
                  </div>
                  <div>
                    <div>{item?.mobileNo || "--"}</div>
                  </div>
                  <div>
                    <div
                      className={`${
                        item?.dmapplogs?.length
                          ? "text-blue-500 cursor-pointer hover:underline"
                          : "text-gray-500"
                      }`}
                      onClick={() =>
                        item?.dmapplogs?.length && openModal(item?.dmapplogs)
                      }
                    >
                      {item?.dmapplogs?.length || 0}
                    </div>
                  </div>
                  <div>
                    <div>{getDate(item?.dmapplogs[0]?.createdAt) || "--"}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-xl flex items-center justify-center mt-5 font-semibold h-[300px]">
              No OTP Logs Found
            </div>
          )}
        </div>
      )}

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-3">
          <CustomPagination
            totalPages={totalPages}
            page={page}
            setPage={setPage}
            disabled={isLoading}
          />
        </div>
      )}

      <TmsOtpLogsModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        hospitalLogs={hospitalLogs}
      />
    </div>
  );
};

export default TmsOtpLogsList;
